import Vue from 'vue';
import { mapGetters } from 'vuex';
import { guid } from '@/mixins/guid';

export default Vue.component('suspend-site', {
  template: require('./template.html'),
  name: 'suspend-site',
  computed: {
    ...mapGetters(['account', 'currentUser', 'identityId']),
    getStatus() {
      return this.currentSite.status === 'live' ? 'suspend' : 'unsuspend';
    },
  },
  mixins: [guid],
  props: ['modal', 'current-site', 'toggle-modal'],
  data() {
    return {
      loading: false,
      suspendErrors: [],
    };
  },
  watch: {
    modal(o) {
      if (o) {
        this.resetModal();
      }
    },
  },
  methods: {
    suspendSite() {
      this.updateOrigin('suspend');
    },
    unsuspendSite() {
      this.updateOrigin('unsuspend');
    },
    async updateOrigin(status) {
      this.loading = true;
      try {
        await this._SEND([{
          name: 'suspendSite',
          payload: {
            site: this.currentSite,
            status,
          },
        }]);
        this.$log.debug('Successfully updated cloudfront and cleared cache');

        // update status in state
        this.$store.dispatch('updateSiteStatus', {
          site: this.currentSite,
          status,
        });
        // finally, close modal
        this.closeModal('suspendSite');
      } catch (e) {
        this.$log.error('error: ', e.message || e);
        this.suspendErrors.push(e.message || e);
        await this._reportError({
          error: e,
          fn: 'updateOrigin',
        });
      } finally {
        this.loading = false;
        this._trackEvent({
          type: 'suspend_site',
          meta: {
            site_name: this.currentSite.alias,
            site_type: this.currentSite.type,
            status,
          },
        });
      }
    },
    resetModal() {
      this.loading = false;
      this.suspendErrors = [];
    },
    closeModal(type) {
      this.$emit('toggle-modal', type, 'child');
    },
    formatErrors(ers) {
      return ers.join(' ');
    },
  },
});



// WEBPACK FOOTER //
// ./src/global-view/admin/websites/edit-site/suspend/index.js